var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedWidget.type === 'input') ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.displayType')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.type),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "type", $$v)
      },
      expression: "optionModel.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "text",
      "value": "text"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "password",
      "value": "password"
    }
  })], 1)], 1) : _vm._e()
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-065a02b6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/type-editor.vue
// module id = null
// module chunks = 